import { css } from "styled-components";

export const userAvatarStyles = {
  userImage: css<{ $size: number }>`
    height: ${(p) => p.$size}px;
    width: ${(p) => p.$size}px;
    border-radius: ${(p) => p.$size / 2}px;
  `,
  fallbackImage: css<{ $size: number; $isApp?: boolean }>`
    height: ${(p) => p.$size}px;
    width: ${(p) => p.$size}px;
    border-radius: ${(p) => p.$size / 2}px;
    background: ${(p) =>
      p.$isApp ? p.theme.colors.buttonBgColor : p.theme.colors.primaryBlue};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  `,
};
